import React, {  } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import TierList from './components/TierList';
import PassList from './components/PassList';
import AntiVirus from './components/AntiVirus';
import PrivacyPolicy from './components/PrivacyPolicy';
import './App.css';

const App = () => {return (
    <Router>
      <div className="app">
        <Header />
        <div className="content-wrapper">
          <Routes>
            <Route path="/" element={<TierList />} />
            <Route path="/passlist" element={<PassList />} />
            <Route path="/antivirus" element={<AntiVirus />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
};

export default App;